<template>
    <div>
        {{user}}
        <v-container fluid  class="pa-5">
            <v-card>
                <v-card-title>Create User</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                            <UserForm v-model="user"/>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>

    import UserForm from "../../components/User/UserForm";
    export default {
        components: {UserForm},
        data() {
            return {
                user: {
                    firstName: null,
                    lastName: null,
                    email: null,
                    roles: []
                }
            }
        },
    }
</script>

<style scoped>

</style>